import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { FieldGroup } from '../FieldGroup.js';
import { FormTitle } from '../FormTitle.js';
import { noop } from '../../../utils/noop.js';
import { tokens } from '@everfi/design-system';
import { ToggleCheckbox } from '../../toggle-checkbox/component.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { Card } from '../../../core/components/Card/card.js';
import { CardBody } from '../../../core/components/Card/card-body.js';
var _excluded = ["children", "className", "data", "description", "isCard", "onToggle", "title", "toggle"];
/** renders a form section */

var FormSection = function FormSection(_ref) {
  var _toggle$style;

  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? null : _ref$data,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? '' : _ref$description,
      _ref$isCard = _ref.isCard,
      isCard = _ref$isCard === void 0 ? false : _ref$isCard,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? noop : _ref$onToggle,
      title = _ref.title,
      _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === void 0 ? null : _ref$toggle,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(function () {
    return !toggle || data && data[toggle.name] || toggle.checked;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      toggled = _useState2[0],
      setToggled = _useState2[1];

  var handleToggle = function handleToggle(value) {
    setToggled(value);
    onToggle(value);
  };

  var sectionClassName = _formatClassName(['form-section', className, {
    'form-section-card': isCard
  }]);

  var inner = /*#__PURE__*/React.createElement(FieldGroup, _extends({}, props, {
    data: data,
    className: sectionClassName
  }), toggle && /*#__PURE__*/React.createElement(ToggleCheckbox, _extends({}, pickDataAttributes(toggle), {
    className: "round sm ".concat((_toggle$style = toggle.style) !== null && _toggle$style !== void 0 ? _toggle$style : ''),
    checked: toggled,
    label: toggle.label,
    name: toggle.name,
    onChange: function onChange(event) {
      handleToggle(event.target.checked);
    }
  })), title && /*#__PURE__*/React.createElement(FormTitle, {
    className: description ? 'with-description' : ''
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: "form-section-description p2"
  }, description), /*#__PURE__*/React.createElement(Collapse, {
    "in": toggled
  }, /*#__PURE__*/React.createElement(FieldGroup, _extends({}, props, {
    data: data
  }), children)));

  if (isCard) {
    return /*#__PURE__*/React.createElement(Layout, {
      marginBottom: tokens.SpacingBaseMd
    }, /*#__PURE__*/React.createElement(Card, {
      variant: "outline",
      sx: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement(Layout, {
      paddingTop: tokens.SpacingBaseMd
    }, /*#__PURE__*/React.createElement(CardBody, null, inner))));
  } else {
    return inner;
  }
};

export { FormSection };